import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import VendorsAddEditForm from './vendormasters-add-edit-form';
import CustomPropTypes from 'Core/prop-types';
import { createVendor, updateVendor } from './store/slice';
import { showToast } from 'Core/redux/toast/slice';

const VendorAddEdit = ({ show, onHide, vendorData }) => {
  const [formData, setFormData] = useState(vendorData || null);
  const dispatch = useDispatch();
  const isEditMode = Boolean(vendorData?.id);

  const onChangesVendorsForm = data => {
    setFormData(data);
  };

  const valid = () => {
    if (!formData || !formData?.vendorName) {
      dispatch(
        showToast({
          message: 'Please enter vendor name',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const onSave = () => {
    if (valid()) {
      const payload = {
        ...formData,
        userId: localStorage.getItem('UserId')
      };
      if (isEditMode) {
        dispatch(updateVendor({ id: vendorData.id, data: payload }));
      } else {
        dispatch(createVendor(payload));
      }
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? 'Edit Vendor' : 'Add Vendor'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <VendorsAddEditForm data={formData} onChanges={onChangesVendorsForm} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={onSave}>
          Save Vendor
        </button>
      </Modal.Footer>
    </Modal>
  );
};

VendorAddEdit.propTypes = {
  show: PropTypes.bool,
  vendorData: PropTypes.shape(CustomPropTypes.Vendor),
  onHide: PropTypes.func,
};

export default VendorAddEdit; 